import type { IAdminOrganizationDto, IUserOrganizationDto } from '@treneo/models';
import { useAppTranslations } from '@treneo/shared/i18n';
import { Box, Chip, Typography } from '@treneo/shared/ui';

type Props = Readonly<{
  organizations?: (IAdminOrganizationDto | IUserOrganizationDto)[] | null;
}>;

export const OrganizationChipsList = ({ organizations }: Props) => {
  const { t } = useAppTranslations();

  if (!organizations || organizations.length === 0) {
    return <Typography variant='body2'>{t('admin.noOrganizations')}</Typography>;
  }

  return (
    <Box display='flex' gap={0.5} flexWrap='wrap' justifyContent='flex-start'>
      {organizations.map(org => {
        const orgId = 'id' in org ? org.id : org.organizationId;
        const orgName = 'name' in org ? org.name : org.organizationName;
        return <Chip key={orgId} label={orgName} size='small' color='default' variant='outlined' />;
      })}
    </Box>
  );
};

OrganizationChipsList.displayName = 'OrganizationChipsList';
